import type {GlobalSearchService} from 'shared/global-search/global-search.service';
import type AutocompleteSearchDataService from 'shared/data-services/autocomplete-search.data-service';
import {lastValueFrom} from 'rxjs';
import {map} from 'rxjs/operators';
import {type Writable, writable} from 'svelte/store';
import {getUrlParams} from 'shared/utils/url-utils';

export class KpGlobalSearchInputPresenter {
    public static presenterName = 'kpSearchInputPresenter';

    private readonly searchQueryStore: Writable<string>;

    /*@ngInject*/
    constructor(private globalSearchService: GlobalSearchService,
                private autocompleteSearchDataService: AutocompleteSearchDataService) {

        this.searchQueryStore = writable(getUrlParams().q ?? '');
    }

    public triggerGlobalSearch(query: string) {
        return this.globalSearchService.search(query);
    }

    public getSearchQueryStore(): Writable<string> {
        return this.searchQueryStore;
    }

    public async getAutocompleteHints(query: string) {
        return lastValueFrom(this.autocompleteSearchDataService.getSearchedTerms(query).pipe(
            map((response) => response.content.map((item) => item.value))
        ));
    }
}